'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

import { GiftCard, TaxDeductionCard } from './BasicCard';
import {
  BenefitCardAnimated,
  PlusIcon,
  SpecialBenefitCardAnimated,
} from './CardAnimated';
import { BenefitHeader } from './Header';
import {
  FriendInviteCard,
  PhotoReviewCard,
  WelloPointCard,
} from './SpecialCard';

const CONTAINER_ANIMATION = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1,
    },
  },
};

const ITEM_ANIMATION = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

export const Benefit = () => {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const isInView1 = useInView(ref1, { once: true, margin: '-100px' });
  const isInView2 = useInView(ref2, { once: true, margin: '-100px' });

  return (
    <section className="w-full">
      <motion.div
        ref={ref1}
        variants={CONTAINER_ANIMATION}
        initial="hidden"
        animate={isInView1 ? 'visible' : 'hidden'}
        className="flex w-full flex-col items-center gap-32 bg-Gray-50 px-0 pb-60 pt-80"
        aria-labelledby="benefit-heading"
      >
        <motion.div variants={ITEM_ANIMATION}>
          <BenefitHeader
            title="웰로 고향사랑기부제 기본 혜택"
            subtitle="13만원 혜택!"
            headingId="benefit-heading"
          />
        </motion.div>

        <div className="flex w-full items-center justify-center gap-12 px-24">
          <BenefitCardAnimated iconDelay={0.3}>
            <TaxDeductionCard />
          </BenefitCardAnimated>

          <BenefitCardAnimated iconDelay={0.4}>
            <GiftCard />
          </BenefitCardAnimated>
        </div>
      </motion.div>

      <div id="benefit" className="relative top-[-68px]" aria-hidden="true" />
      <motion.div
        ref={ref2}
        variants={CONTAINER_ANIMATION}
        initial="hidden"
        animate={isInView2 ? 'visible' : 'hidden'}
        className="flex w-full flex-col items-center gap-32 bg-Gray-white px-0 py-60"
        aria-labelledby="special-benefit-heading"
      >
        <motion.div variants={ITEM_ANIMATION}>
          <BenefitHeader
            title="웰로에서 기부하면"
            subtitle="특별 혜택 100% 드려요"
            headingId="special-benefit-heading"
          />
        </motion.div>

        <div className="relative flex w-full items-center justify-center gap-4 px-24">
          <SpecialBenefitCardAnimated>
            <WelloPointCard />
            <PlusIcon delay={0.85} isInView={isInView2} />
          </SpecialBenefitCardAnimated>

          <SpecialBenefitCardAnimated>
            <PhotoReviewCard />
            <PlusIcon delay={1.05} isInView={isInView2} />
          </SpecialBenefitCardAnimated>

          <SpecialBenefitCardAnimated>
            <FriendInviteCard />
          </SpecialBenefitCardAnimated>
        </div>
      </motion.div>
    </section>
  );
};
